import {
  FlexContainer,
  IStyleProps,
  SapphireBlueButton,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import React, { Component } from "react";
import styled from "styled-components";
import MindMeLogo from "../../../../../../images/logos/mindme-payments-logo-center.png";
// import CheckIcon from "../../../../../../images/common/check-hollow-blue.svg";
import CheckIcon from "../../../../../../images/common/check-fill-blue.svg";
import { NavigateFunction } from "react-router-dom";
import { RolesAndPermissionStore } from "../../../shared/store";
import { AuthService } from "../../../shared/services";

const MerchantPlhBox = styled.div`
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3rem;
  width: 100%;
  text-align: center;
  min-height: 100%;
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  > div {
    max-width: 800px;
    margin: 0 auto;
  }
  .merchant-plh-logo {
    width: 250px;
  }
  .application-btns {
    button {
      min-width: 230px;
      height: 50px;
      font-size: 20px;
      line-height: 25px;
    }
  }
`;

const MerchantPlhDescription = styled.div<IStyleProps>`
  font-size: 20px;
  color: #555;
  margin-bottom: 1.5rem;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
  margin: ${(props) => props.margin || "0px"};
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin: 4rem auto;
  padding-left: 80px;
`;

const Feature = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  img {
    height: 24px;
    width: 24px;
    margin-bottom: 3px;
  }
`;

const FeatureText = styled.span`
  color: #556bb8;
  font-size: 20px;
  line-height: 24px;
  font-weight: 400;
`;

const features = [
  "Quick Approval",
  "Flexible Payment Options",
  "Next Day Funding",
  "Advanced Billing Choices",
  "Competitive Rates",
  "Fully Integrated",
];

interface IProps {
  navigate: NavigateFunction;
  rolesAndPermissionStore: RolesAndPermissionStore;
}
export class NoMerchantAccountPlaceholder extends Component<IProps> {
  onClickApplyNow() {
    if(AuthService.isMindMeContactRoute){
      const message = {
        type:"showMoneyTab",
      }
      window.parent.postMessage(JSON.stringify(message), "*");
      return;
    }
    if (
      !this.props.rolesAndPermissionStore.hasManagePermission(
        "Apply for Merchant Account"
      )
    ) {
      return;
    }
    this.props.navigate("/app/merchant-accounts/create-new");
  }

  render() {
    return (
      <MerchantPlhBox>
        <div>
          <img src={MindMeLogo} className="merchant-plh-logo" />
          <FeaturesGrid>
            {features.map((feature, index) => (
              <Feature key={index}>
                <img src={CheckIcon} alt="Check Icon" />
                <FeatureText>{feature}</FeatureText>
              </Feature>
            ))}
          </FeaturesGrid>

          <div>
            <FlexContainer
              fxLayout="column"
              justifyContent="center"
              alignItems="center"
            >
              <MerchantPlhDescription>
                MindMe offers a convenient, flexible and user friendly payment &
                billing solution that's fully integrated with your favorite
                MindMe features.
              </MerchantPlhDescription>

              <MerchantPlhDescription margin="20px 0px 50px">
                Get your MindMe merchant account today!
              </MerchantPlhDescription>

              <SapphireBlueButton
                primary
                height="50px"
                fontSize="22px"
                lineHeight="25px"
                onClick={() => this.onClickApplyNow()}
              >
                Apply Now
              </SapphireBlueButton>
            </FlexContainer>
          </div>
        </div>
      </MerchantPlhBox>
    );
  }
}

export default withRouter(NoMerchantAccountPlaceholder);
